import { Button, Col, Row } from "antd";
import "./styles.css";
import {
  UserFormAction,
  UserQuantity,
  UserSearch,
  UsersList,
} from "../../components/User";
import { useEffect, useState } from "react";
import { getAllUsers } from "../../app/features/users/thunks";
import { useDispatch } from "react-redux";
import { PlusOutlined } from "@ant-design/icons";
import { getDepartments } from "../../services/department";
import { getSites } from "../../services/site";
import { useTranslation } from "react-i18next";
import CountData from "../../common/CountData";

const initStateModal = {
  isOpenModal: false,
  isCreate: false,
  titleModal: "",
  buttonOkModal: "",
  editData: {},
};

export default function User() {
  document.title = "Quản lý nhân viên";
  const { t } = useTranslation();
  const [stateModal, setStateModal] = useState(initStateModal);
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const [sites, setSites] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 18,
    totalCount: 0,
  });
  const [loadingData, setLoadingData] = useState(false);
  const [totalUser, setTotalUser] = useState();
  const [department, setDepartmentData] = useState([]);

  useEffect(() => {
    getUsers();
    return () => {};
  }, [dispatch, pagination.pageIndex, pagination.pageSize]);

  useEffect(() => {
    fetchSites();
    getDepartment();
    return () => {};
  }, []);

  const getDepartment = async () => {
    try {
      const res = await getDepartments();
      if (res) {
        setDepartmentData(res.data);
      }
    } catch (error) {}
  };

  const fetchSites = async () => {
    try {
      const { data } = await getSites({ pageSize: 100 });
      setSites(data);
    } catch (error) {
      console.log(error);
    }
  };

  const onLoadMore = () => {
    const newPageSize = pagination.pageSize + 18;
    setPagination((prevPagination) => ({
      ...prevPagination,
      pageSize: newPageSize,
    }));
    setUsers(
      users.concat(
        [...new Array(20)].map(() => ({
          loading: true,
        }))
      )
    );
  };

  const loadMore =
    pagination.pageIndex * pagination.pageSize < pagination.totalCount ? (
      <div
        style={{
          textAlign: "center",
          marginTop: 12,
          height: 32,
          lineHeight: "32px",
        }}
      >
        <Button className="load-more-btn" onClick={onLoadMore}>
          {t("see_more")}
        </Button>
      </div>
    ) : null;

  const getUsers = async (filter = {}) => {
    try {
      setLoadingData(true);
      const sort = {
        sortBy: "id",
        sortType: "DESC",
      };
      const res = await dispatch(
        getAllUsers({ ...filter, ...pagination, ...sort })
      );

      if (res.payload.data) {
        setUsers(res.payload?.data?.data);
        setPagination((prevPagination) => ({
          ...prevPagination,
          totalCount: res.payload?.data?.total,
        }));
        setTotalUser(res.payload?.data?.total);
        setLoadingData(false);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  const actionUsers = (data, type) => {
    switch (type) {
      case "create":
        getUsers();
        break;
      case "update":
        getUsers();
        break;
      case "delete":
        getUsers();
        break;
      case "search":
        getUsers(data);
        break;
      // case "cancel":
      //   getUsers();
      //   break;
      default:
        break;
    }
  };

  const createUser = () => {
    setStateModal({
      isOpenModal: true,
      isCreate: true,
      titleModal: t("create_new_employee"),
      buttonOkModal: t("add"),
      editData: null,
    });
  };

  const updateUser = (data) => {
    setStateModal({
      isOpenModal: true,
      isCreate: false,
      titleModal: t("edit_employee"),
      buttonOkModal: t("edit"),
      editData: data,
    });
  };

  const closeModal = () => {
    setStateModal(initStateModal);
  };

  return (
    <>
      <Row justify="start">
        <Col className="page-heading text-lg font-semibold">
          <p>{t("list_employee")}</p>
        </Col>
      </Row>
      <Row className="!mx-0">
        <Col span={21}>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <UserSearch actionUsers={actionUsers} department={department} />
            </Col>

            <Col span={4} className="flex items-center">
              <CountData total={totalUser} title={t("total_employee")} text={t("employee")} loading={loadingData} />
            </Col>
          </Row>
        </Col>
        <Col span={3}>
          <Button
            onClick={createUser}
            size="large"
            className="align-right text-[0.9rem]"
            type="primary"
          >
            <PlusOutlined />
            {t("create_employee")}
          </Button>
          <UserFormAction
            stateModal={stateModal}
            closeModal={closeModal}
            actionUsers={actionUsers}
            department={department}
            sites={sites}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <UsersList
            loadingData={loadingData}
            updateUser={updateUser}
            actionUsers={actionUsers}
            loadMore={loadMore}
            users={users}
            department={department}
          />
        </Col>
      </Row>
    </>
  );
}
